/**
 * Key used for storing the redirect URI in session storage
 */
export const REDIRECT_URI_KEY = 'redirect-uri';

/**
 * Paths that should not be stored as redirect URIs
 */
const EXCLUDED_PATHS = ['/', '/login', '/local-login', '/logout', '/auth'];

/**
 * Checks if there is a stored redirect URI
 *
 * @returns boolean indicating if a redirect URI exists
 */
export function hasRedirectUri(): boolean {
  if (typeof window === 'undefined') return false;
  const uri = sessionStorage.getItem(REDIRECT_URI_KEY);
  return Boolean(uri);
}

/**
 * Stores the current URI to redirect to after authentication
 * Uses sessionStorage to ensure the URI is cleared when the session ends
 *
 * @param uri - The URI to store for post-authentication redirect
 * @returns void
 */
export function setRedirectUri(uri: string): void {
  if (typeof window === 'undefined' || !uri || EXCLUDED_PATHS.includes(uri)) return;
  sessionStorage.setItem(REDIRECT_URI_KEY, uri);
}

/**
 * Retrieves the stored redirect URI
 *
 * @returns The stored URI or empty string if none exists
 */
export function getRedirectUri(): string {
  if (typeof window === 'undefined') return '';
  return sessionStorage.getItem(REDIRECT_URI_KEY) ?? '';
}

/**
 * Removes the stored redirect URI from session storage
 */
export function clearRedirectUri(): void {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(REDIRECT_URI_KEY);
}
